
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class AlertListService {

    public emailList: string[] = [
    ];

    constructor(
        //private http: HttpClient,
        //private authService: AuthService,
        //private router: Router
    ) {

        // console.log("construct", this.emailList)
    }

    addEmail(email: string) {
        this.emailList.push(email);
    }

    removeEmail(email:string) {
        const itemIndex = this.emailList.indexOf(email);

        this.emailList = this.emailList.filter((item) => {
            return item !== email;
        });
    }

    getList() {
        return this.emailList;
    }

    getEmail() {
        return this.emailList.join(";")
    }

    clearList() {
        this.emailList = []
    }

}